import { useFlags } from '@mint-lib/routing-context';
import {
  ChatSendButton,
  ChatStopButton,
  ChatVoiceButton,
} from '@mint-lib/tw-components/ai';

type Props = {
  hasMessage: boolean;
  isDisabled: boolean;
  isInterruptible?: boolean;
  isS2SMode: boolean;
  isInterruptSuccess?: boolean;
  isInterruptPending?: boolean;
  handleSendQuestion: () => void;
  onStartVoiceChat?: () => void;
  onInterrupt?: () => void;
};

export const SendMessageButton = ({
  hasMessage,
  isS2SMode,
  isDisabled,
  isInterruptible,
  isInterruptSuccess,
  isInterruptPending,
  handleSendQuestion,
  onStartVoiceChat,
  onInterrupt,
}: Props) => {
  const ff = useFlags('@mint/arm', ['aiHubS2S']);

  const isS2SAvailable = ff.aiHubS2S.enabled && onStartVoiceChat;

  if (isS2SAvailable && isS2SMode && !isDisabled) {
    return (
      <span
        className="contents"
        data-dd-action-name="AI chat input: start voice chat"
      >
        <ChatVoiceButton onClick={onStartVoiceChat} />
      </span>
    );
  }

  if (isInterruptible && !isInterruptSuccess) {
    return (
      <span
        className="contents"
        data-dd-action-name="AI chat input: stop request"
      >
        <ChatStopButton isLoading={isInterruptPending} onClick={onInterrupt} />
      </span>
    );
  }

  return (
    <span className="contents" data-dd-action-name="AI chat input: send">
      <ChatSendButton
        onClick={handleSendQuestion}
        disabled={isDisabled || !hasMessage}
      />
    </span>
  );
};
